// import React from 'react'
import useSWR from 'swr'

export default function useMerchant() {
  const {data: merchant, error, isValidating} = useSWR(`merchants/me`)
  
  return {
    merchant: merchant?.data,
    isLoading: isValidating,
    isError: error
  }
}
